export function requiredParams(param) {
  throw new Error(`Missing critical parameter: ${param}`);
}
